module.exports = __webpack_public_path__ + "media/images/logos/Mount-Carmel-College-d4f02ec2ad8c1086e011e7a909c44f18.svg";